import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../authentication';
import { AuthGuard } from '@app/core/guards/auth.guard';
import { Permission } from '@app/core/authentication/permission';

@Injectable({ providedIn: 'root' })
export class SettingsAuthGuard extends AuthGuard implements CanActivate {
    constructor(
        protected router: Router,
        protected authenticationService: AuthenticationService
    ) {
        super(router, authenticationService);
    }

    protected permissionsCheck(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const hasPermission = this.authenticationService.currentUserValue.hasPermissions(Permission.SMP_SETTINGS);

        if (hasPermission) {
            return Promise.resolve(hasPermission);
        } else {
            return this.unauthorisedAction();
        }
    }
}
